import { createAction, props } from '@ngrx/store';
import { EstruturaRetornoDadosOutputDto } from 'src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto';
import { EdicaoOutputDto } from 'src/app/domain/DTOs/output/jornal/edicao-output.dto';
const actionName = "[ ObterEdicaoPorData ] Obter Edicao Por Data Publicacao";

export const obterEdicaoPorData = createAction(
  actionName,
  props<{ inputDto: string}>()
);

export const obterEdicaoPorDataSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosOutputDto<EdicaoOutputDto> }>()
);

export const obterEdicaoPorDataFailure = createAction(
  `${actionName} - Falha`,
  props<{ response: EstruturaRetornoDadosOutputDto<EdicaoOutputDto> }>()
);

export const obterEdicaoPorDataFinish = createAction(
  `${actionName} - Concluir`
);
